/**
 * Desktop background — CSS-only static layer.
 *
 * v2: replaced animated MeshGradient from @paper-design/shaders-react
 *     with a calm static CSS background. No WebGL, no shaders, no
 *     continuous animation frames. Paints once with --khal-bg base,
 *     a single radial accent glow, and the Khal logo watermark.
 *
 * Composed behind all shell chrome at z-index: 0, pointer-events none.
 */
export function DesktopBackground() {
	return (
		<div
			style={{
				position: 'fixed',
				inset: 0,
				zIndex: 0,
				pointerEvents: 'none',
				background: `
					radial-gradient(
						circle at 50% 38%,
						color-mix(in oklch, var(--khal-accent) 5%, transparent) 0%,
						color-mix(in oklch, var(--khal-accent) 2%, transparent) 35%,
						transparent 70%
					),
					var(--khal-bg)
				`,
			}}
		/>
	);
}
